<template>
  <div>
  
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <v-text-field 
            v-model="alumno.nombre" 
            :rules="nombreRules"
            label="Apellidos, Nombre*" 
            required
        ></v-text-field>
      </v-col>
        
      <v-col cols="12" sm="6" md="6">
        <v-text-field 
            v-model="alumno.dni"
            label="Dni" 
            required
        ></v-text-field>
      </v-col>
        
    </v-row>

    <v-row>

      <v-col cols="12" sm="6" md="6">
            
        <date-picker
        v-model="alumno.fechaNacimiento"
        label="Fecha Nacimiento*"
        :rules="dateRules"
        :max="getEndDate"
        ></date-picker>
        
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-text-field 
            v-model="alumno.telefono"
            label="Teléfono" 
            required
        ></v-text-field>
      </v-col>

    </v-row>
  
  </div>

</template>


<script>

import DateUtils from '@/libraries/DateUtils'
import DatePicker from '@/components/DatePicker'

export default {
  name: 'AlumnoDatosFormFields',

  props: {
    
    alumno: {
      type: Object,
      required: true
    },

    nombreRules: {
      type: Array,
      default: () => []
    },

    dateRules: {
      type: Array,
      default: () => []
    }

  },

  components: {
    DatePicker
  },

  computed: {
    getEndDate() {
     let dateUtils = new DateUtils()
     return dateUtils.formatDateYYYYMMDD()
    }
  }
  
}

</script>